import { useDesignMaxTheme } from "@/packages";
import { Center, Flex } from "@chakra-ui/react";
import { type RoomListType } from "../otherRoomPreview/otherRoomPreview.type";
import { RoomDesc, RoomPhoto } from "./components";

export const RoomDetail = ({ room }: { room: RoomListType }) => {
    const { MEDIAS } = useDesignMaxTheme();
    const { isMobile } = MEDIAS();

    // const { ref, inView } = useInView({ threshold: 0.9, delay: 0.3, triggerOnce: true });

    return (
        <Center position="relative" width="100%" background="#fff">
            <Flex as="section" p={isMobile ? "8px 0 24px 0" : "120px 0"} flexDir={isMobile ? "column" : "row"}>
                <RoomPhoto room={room} />
                <RoomDesc room={room} />
            </Flex>
        </Center>
    );
};
